module.exports = __webpack_public_path__ + "img/hero2.9704da8c.png";